
import { Component, Vue } from "vue-property-decorator";
import config from "./config";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import Scan from "@/views/components/Scan/Scan.vue";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
import { getCarInfoByCode, getCQInfoByCode } from "@/api/service";
import { LogHelper } from "@/common/LogHelper";
import dayjs from "dayjs";
import { WeighbridgeBll } from "@/common/glboalconstant";
import {
  ApiQueryType,
  SendDataType,
  ReceiveDataType,
} from "@/common/glboalconstant";
import { ScanforWeighBridgeModule } from "@/store/modules/store_scanforweighbridge";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

@Component({
  name: "Form2",
  components: {
    YtoTable,
    Scan,
  },
  computed: {
    activePageNow() {
      return ScanforWeighBridgeModule.activePage;
    },
  },
  watch: {
    activePageNow: function(now) {
      if (now == "tare") {
        //注册回调：从Dws获取数据，客户端需注册
        if (typeof obj_DWS_Core !== "undefined") {
          obj_DWS_Core.registerJavaScriptCallback(
            "DWSReceiveDataSetPackageData",
            (value) => {
              LogHelper.Console("DWS传输过来的参数1");
              LogHelper.Console(value);
              this.ReceiveDataEvent(JSON.parse(value));
            }
          );
        }
      }
    },
  },
})
export default class extends Vue {
  public globalConfig: any = {};
  public loginData: any = {};
  mounted() {
    try {
      this.globalConfig = SystemConfigModule.globalData;
      this.loginData = SystemConfigModule.loginData;
    } catch (error) {
      console.log(error);
    }
  }
  private ReceiveDataEvent(receiveDataEventArgs) {
    switch (receiveDataEventArgs.ReceiveDataType) {
      case ReceiveDataType.CameraState:
        break;
      case ReceiveDataType.PackageData:
        this.SetPackageData(
          JSON.parse(receiveDataEventArgs.JsonData.toString())
        );
        break;
      case ReceiveDataType.CodeCheck:
        break;
      case ReceiveDataType.ErrorState:
        break;
      case ReceiveDataType.ErrorInfo:
        this.SetErrorInfo(JSON.parse(receiveDataEventArgs.JsonData.toString()));
        break;
    }
  }
  /// <summary>
  /// 获得底层数据
  /// </summary>
  /// <param name="data"></param>
  private SetPackageData(data) {
    this.WeighResponse(parseFloat(data.weight.toString()));
  }
  /// <summary>
  /// 称重-Response
  /// </summary>
  private WeighResponse(weight) {
    debugger;

    //txtTareWeight.Text = weight.ToString();
    //txtWeightDate.Text = DateTime.Now.ToString("yyyy-MM-dd HH:mm:ss");
    this.formmodel2.input_TareWeight = weight.toString();
    this.formmodel2.input_WeightDate = dayjs().format("YYYY-MM-DD HH:mm:ss"); //DateTime.Now.ToString("yyyy-MM-dd HH:mm:ss");
    // callbackdic["updateformdatacallback"]?.ExecuteAsync(SCANOBJECT);
  }
  private SetErrorInfo(errorInfo) {
    if (errorInfo.ErrorString.indexOf("重量") != -1) {
      this.CleanWeightInput();
    }
    this.errormessage = errorInfo.ErrorString;
  }
  /// <summary>
  /// 清空重量
  /// </summary>
  private CleanWeightInput() {
    //txtTareWeight.Text = string.Empty;
    //txtWeightDate.Text = string.Empty;
    this.formmodel2.input_TareWeight = "";
    this.formmodel2.input_WeightDate = "";
    // if (callbackdic.ContainsKey("updateformdatacallback"))
    // {
    //     callbackdic["updateformdatacallback"]?.ExecuteAsync(SCANOBJECT);
    // }
  }
  public selectElementContents(el) {
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  public updateformdatacallback(result) {
    if (
      this.formmodel2.input_LicensePlateNumber !=
      result.input_LicensePlateNumber
    ) {
      this.formmodel2.input_LicensePlateNumber =
        result.input_LicensePlateNumber;
    }
    if (this.formmodel2.input_OldTareWeight != result.input_OldTareWeight) {
      this.formmodel2.input_OldTareWeight = result.input_OldTareWeight;
    }
    if (this.formmodel2.input_WeightDate != result.input_WeightDate) {
      this.formmodel2.input_WeightDate = result.input_WeightDate;
    }
    if (this.formmodel2.input_CarSign != result.input_CarSign) {
      this.formmodel2.input_CarSign = result.input_CarSign;
    }
    if (this.formmodel2.input_CarType != result.input_CarType) {
      this.formmodel2.input_CarType = result.input_CarType;
    }
    if (this.formmodel2.input_TareWeight != result.input_TareWeight) {
      this.formmodel2.input_TareWeight = result.input_TareWeight;
    }
  }

  public datahistorycallback(datalist) {
    this.showPrintedList = datalist;
  }
  //错误消息回调显示方法
  public errormsgcallback(data) {
    this.errormessage = data;
  }
  public PrintAndUploadFunc() {
    this.PrintAndUpload();
  }
  /// <summary>
  /// 打印上传
  /// </summary>
  public PrintAndUpload() {
    debugger;
    ////进场时对比净重
    //if (SCANOBJECT["input_IoStatus"] == "1")
    //{
    //    string suttleWeight = string.IsNullOrEmpty(SCANOBJECT["input_SuttleWeight"]) ? "0" : SCANOBJECT["input_SuttleWeight"];
    //    string netWeight = string.IsNullOrEmpty(SCANOBJECT["input_NetWeight"]) ? "0" : SCANOBJECT["input_NetWeight"];
    //    if (System.Math.Abs(Convert.ToDouble(suttleWeight) - Convert.ToDouble(netWeight)) >= 500)
    //    {
    //        MessageFrm.NoticeFrmShow("本次称重（净重）与上一中心（净重）差\r\n异过大，是否继续上传！", "否", "继续上传");
    //        if (!MessageFrm.bIsCancel)
    //        {
    //            return;
    //        }
    //    }
    //}
    try {
      // SCANOBJECT = Object;

      let response = this.Upload();
      if (response == null || response.data == null) {
        return;
      }
      let tarePrintDataModel = {
        carNumber: response.data.carNumber,
        carSign: response.data.carSign,
        carType: response.data.carType,
        opOrgName: response.data.opOrgName,
        tareWeight: response.data.tareWeight,
        weighDate: response.data.weighDate,
      };
      // new PrintTicket(tarePrintDataModel);
      obj_ScanForWeighbridge.printTicket(
        "tare",
        JSON.stringify(tarePrintDataModel)
      );
    } catch (ex) {
      LogHelper.WriteLog("打印失败:" + ex.toString());
      this.errormessage = "打印失败, 错误信息:" + ex;
    }
  }
  public UploadFunc() {
    this.Upload();
  }
  /// <summary>
  /// 上传重量
  /// </summary>
  public Upload() {
    // SCANOBJECT = Object;
    //if (string.IsNullOrEmpty(comboBox1.Text))
    if (
      this.IsNullorEmptyorUndefined(this.formmodel2.input_LicensePlateNumber)
    ) {
      this.errormessage = "车牌不能为空";
      return null;
    }

    //if (string.IsNullOrEmpty(txtTareWeight.Text) || txtTareWeight.Text.ToDouble() <= 0)
    if (
      this.IsNullorEmptyorUndefined(this.formmodel2.input_TareWeight) ||
      parseFloat(this.formmodel2.input_TareWeight.toString()) <= 0
    ) {
      this.errormessage = "请称重";
      return null;
    } else {
      let input_TareWeight = this.formmodel2.input_TareWeight.toString();
      if (parseFloat(input_TareWeight) <= 0) {
        this.errormessage = "请称重";
        return null;
      }
    }

    var request = this.GetUploadTareWeightRequest(this.formmodel2);
    // var response = JSON.parse(uploadTareWeight(JSON.stringify(request)));
    var response = JSON.parse(
      obj_HttpRequest_Core.post(
        "/Yto_BusiGateway/client/loadometer/uploadTareWeight",
        JSON.stringify(request)
      )
    );
    if (response == null || response.respcode != "000") {
      this.errormessage =
        "上传失败, 错误信息:" +
        response.respMessage +
        "，错误代码：" +
        response.respcode;
      return null;
    }

    //MessageBox.Show("操作成功", "操作成功", MessageBoxButtons.OK, MessageBoxIcon.Information);
    // callbackdic["errormsgcallback"]?.ExecuteAsync("操作成功");

    if (response.data != null) {
      this.InsertMyDataView(response.data);
    }

    this.CleanInput();
    // callbackdic["updateformdatacallback"]?.ExecuteAsync(SCANOBJECT);

    return response;
  }
  /// <summary>
  /// 上传成功，清空文本框
  /// </summary>
  private CleanInput() {
    //comboBox1.Text = string.Empty;
    //txtCarSign.Text = string.Empty;
    //txtCarType.Text = string.Empty;
    //txtOldTareWeight.Text = string.Empty;
    //txtTareWeight.Text = string.Empty;
    //txtWeightDate.Text = string.Empty;
    //tbx_scanArea.Text = string.Empty;
    this.formmodel2.input_LicensePlateNumber = "";
    this.formmodel2.input_CarSign = "";
    this.formmodel2.input_CarType = "";
    this.formmodel2.input_OldTareWeight = "";
    this.formmodel2.input_TareWeight = "";
    this.formmodel2.input_WeightDate = "";
    this.formmodel2.input_ScanCode = "";
    // if (callbackdic.ContainsKey("updateformdatacallback"))
    // {
    //     callbackdic["updateformdatacallback"]?.ExecuteAsync(SCANOBJECT);
    // }
  }
  /// <summary>
  /// 新增列表
  /// </summary>
  /// <param name="data"></param>
  /// <returns></returns>
  private InsertMyDataView(data) {
    ////DataGridViewRow Row = new DataGridViewRow();
    ////Row.CreateCells(dataGridView1);
    ////Row.Cells[0].Value = data.carNumber;
    ////Row.Cells[1].Value = data.tareWeight;
    ////Row.Cells[2].Value = data.weighDate;
    ////Row.Cells[3].Value = data.carSign;
    ////Row.Cells[4].Value = data.carType;
    ////Row.Cells[5].Value = data.opOrgName;
    ////Row.Cells[6].Value = data.opUserName;
    ////Row.Cells[7].Value = (data.status == "1" ? "已上传" : "未上传");
    ////Row.Cells[8].Value = data.memo;
    ////dataGridView1.Rows.Insert(0, Row);

    ////if ((dataGridView1.RowCount > 0) && (dataGridView1.ColumnCount > 0))
    ////{
    ////    dataGridView1.CurrentCell = dataGridView1.Rows[0].Cells[0];
    ////    dataGridView1.Rows[0].Height = 40;
    ////}
    ///

    this.showPrintedList.push({
      carNumber: data.carNumber,
      tareWeight: data.tareWeight,
      weighDate: data.weighDate,
      carSign: data.carSign,
      carType: data.carType,
      opOrgName: data.opOrgName,
      opUserName: data.opUserName,
      status: data.status == "1" ? "已上传" : "未上传",
      memo: data.memo,
    });
//未开放
    // if (this.showPrintedList.length > 50) {
    //   this.showPrintedList.pop();
    // }
    return true;
  }
  /// <summary>
  /// 获得当前上传重量请求信息
  /// </summary>
  /// <returns></returns>
  private GetUploadTareWeightRequest(Object) {
    return {
      devMac: this.globalConfig.LocalMac,
      devType: "0",
      body: {
        aviType: 0,
        isFirstTransfer: 1,
        mac: this.globalConfig.LocalMacIPv4,
        mty: "0140",
        trace: 0,
        opRecord: {
          carNumber: Object.input_LicensePlateNumber,
          opUserCode: this.loginData.userCode,
          opUserName: this.loginData.employeeName,
          tareWeight: Object.input_TareWeight,
          carSign: Object.input_CarSign,
          carType: Object.input_CarType,
          weighDate: Object.input_WeightDate,
        },
      },
    };
  }
  public ReweighFunc() {
    this.formmodel2.input_ScanCode = this.ytoCode.toUpperCase();
    this.Reweigh();
  }
  public Reweigh() {
    debugger;
    this.WeighRequest(this.formmodel2.input_ScanCode);
  }
  /// <summary>
  /// 称重-Request
  /// </summary>
  private WeighRequest(key) {
    if (
      this.IsNullorEmptyorUndefined(this.formmodel2.input_LicensePlateNumber)
    ) {
      this.errormessage = "车牌号不能为空";
      return;
    }
    if (this.globalConfig.WeighConfig.On) {
      var weight = 0.0;
      try {
        // weight = GetWeight(key);
        weight = this.GetWeight(key);
      } catch (ex) {
        this.errormessage = "取重错误:" + ex;
        return;
        //throw;
      }
      if (weight < 0) {
        this.errormessage = "重量无法获取";
        return;
      }
      this.formmodel2.input_TareWeight = weight.toFixed(2);
      this.formmodel2.input_WeightDate = dayjs().format("YYYY-MM-DD HH:mm:ss");
    }
    // ScanForWeighbridge.Form_ScanForWeighbridge.HKSocket.SynSendDataCallBack(
    //   SendDataType.SuppleCode,
    //   WeighbridgeBLL.DefaultWaybillNo
    // );
    else
      obj_DWS_Core.hKSocketSynSendDataCallBack(
        SendDataType.SuppleCode,
        WeighbridgeBll.DefaultWaybillNo
      );
  }
  //取重方法
  private GetWeight(scanContent) {
    try {
      let weight = obj_Weight_Core.weighbridgeGetWeight(scanContent);
      weight = Math.floor(weight * 100) / 100;
      return weight;
    } catch (error) {
      return 0;
    }
  }
  //字符串为null、空、未定义判断
  private IsNullorEmptyorUndefined(data) {
    if (data == null || data == undefined || data == "") {
      return true;
    } else {
      return false;
    }
  }
  public loading = false;
  public list = [];
  public option = [];
  public remoteMethod(query) {
    if (query !== "") {
      this.loading = true;
      let result = this.QueryCP(query);
      var resultObj = JSON.parse(result);
      this.list = resultObj.CPList.map((item) => {
        return { value: `${item}`, label: `${item}` };
      });
      setTimeout(() => {
        this.loading = false;
        this.option = this.list.filter((item) => {
          return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1;
        });
      }, 200);
    } else {
      this.option = [];
    }
  }

  public QueryCP(Object) {
    debugger;
    try {
      let _list = [];

      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          dbType: "1",
          columns: "VEHICLE_PLATE_NO",
          tableName: "t_exp_vehicle",
          condition: "VEHICLE_PLATE_NO like " + "'%" + Object.toString() + "%'",
          descs: "",
          ascs: "",
          current: "",
          size: "5",
        },
      };
      var response = JSON.parse(
        obj_HttpRequest_Core.post(
          "/Yto_BusiGateway/client/query/table",
          JSON.stringify(request)
        )
      );
      if (response.respcode != "000") {
        LogHelper.WriteLog("查询失败" + response.respMessage);
      } else {
        let jsData = response.data.busiData;
        let str = this.CleanString(JSON.stringify(jsData.records));
        let jArray = JSON.parse(str);

        jArray.forEach((item) => {
          let jdata = item;
          if (jdata.VEHICLE_PLATE_NO != null) {
            //comboBoxCP.Items.Add(jdata["VEHICLE_PLATE_NO"]);
            _list.push(jdata.VEHICLE_PLATE_NO.toString());
          }
        });
      }
      let queryCPResponse = { CPList: _list, query: Object };

      return JSON.stringify(queryCPResponse);
    } catch (ex) {
      LogHelper.WriteLog(ex);
      return JSON.stringify({ CPList: [], query: Object });
    }
  }

  private CleanString(newStr) {
    let tempStr = newStr.replace("\n", "");
    tempStr = tempStr.replace("\r", "");
    return tempStr;
  }

  private errormessage = "";
  private deviceItems: deviceItem[] = [];
  public ytoCode = "";

  //扫描区扫码
  private ytocodeget() {
    this.formmodel2.input_ScanCode = this.ytoCode.toUpperCase();
    this.QueryFacade();
  }
  //界面触发查询
  public QueryFacade() {
    debugger;
    // callbackdic["errormsgcallback"]?.ExecuteAsync("");
    this.errormessage = "";
    // SCANOBJECT = Object;

    if (this.IsNullorEmptyorUndefined(this.formmodel2.input_ScanCode)) {
      this.errormessage = "条码不能为空";
      return;
    }

    let cqFlag = false;
    let _code: any = this.formmodel2.input_ScanCode;
    var rg = JSON.parse(
      obj_HttpRequest_Core.checkCodesAndType(_code.split(), null, null)
    );
    if (rg.ResultCode == "200" && rg.Type == ApiQueryType.strCarCode) {
      if (
        _code.toString().indexOf("CQ") != -1 &&
        _code.toString().length == 20
      ) {
        this.errormessage = "系统生成的车签，不允许人工录入";
        return;
      }
      cqFlag = true;
    }

    var cpFlag = WeighbridgeBll.RegularByCP(this.formmodel2.input_ScanCode);

    if (cqFlag == false && cpFlag == false) {
      this.errormessage = "条码错误";
      return;
    }

    if (cqFlag) {
      this.CQQuery(this.formmodel2.input_ScanCode);
    } else if (cpFlag) {
      this.CPQuery(this.formmodel2.input_ScanCode);
    }
    // callbackdic["updateformdatacallback"]?.ExecuteAsync(SCANOBJECT);
  }

  /// <summary>
  /// 车签查询
  /// </summary>
  private CQQuery(cqNo) {
    debugger;
    let request = {
      devType: "0",
      devMac: this.globalConfig.LocalMac,
      body: {
        viewType: "1",
        queryValue: cqNo,
        queryType: "17",
      },
    };
    var response = JSON.parse(getCQInfoByCode(JSON.stringify(request)));
    if (response == null || response.respcode != "000") {
      this.errormessage =
        "车签查询失败, 错误信息:" +
        response.respMessage +
        "，错误代码：" +
        response.respcode;
      return;
    }

    if (
      this.IsNullorEmptyorUndefined(response?.data?.carNumber) &&
      this.IsNullorEmptyorUndefined(response?.data?.carNumberExtend)
    ) {
      this.errormessage = "查询不到该车签对应的运营单，请创单后再进行过磅！";
      return;
    }

    if (
      !this.IsNullorEmptyorUndefined(response.data.carNumber) &&
      !this.IsNullorEmptyorUndefined(response.data.carNumberExtend)
    ) {
      let msg =
        "车牌号码为" +
        response.data.carNumber +
        "，挂车车牌为" +
        response.data.carNumberExtend +
        "。\r\n请选择";
      // CustomDialogButton2 customDialogButton2 = new CustomDialogButton2();
      // var dialog = customDialogButton2.ShowMsg(msg, response.data.carNumber, response.data.carNumberExtend, 120, 120);
      this.$confirm(msg, "提示", {
        confirmButtonText: response.data.carNumber,
        cancelButtonText: response.data.carNumberExtend,
        type: "warning",
      })
        .then(() => {
          this.CPQuery(response.data.carNumber);
        })
        .catch(() => {
          this.CPQuery(response.data.carNumberExtend);
        });
    } else if (!this.IsNullorEmptyorUndefined(response.data.carNumber)) {
      this.CPQuery(response.data.carNumber);
    } else if (!this.IsNullorEmptyorUndefined(response.data.carNumberExtend)) {
      this.CPQuery(response.data.carNumberExtend);
    }
  }
  /// <summary>
  /// 车牌查询
  /// </summary>
  private CPQuery(cpNo) {
    debugger;

    let request = {
      devType: "0",
      devMac: this.globalConfig.LocalMac,
      body: {
        viewType: "1",
        queryValue: cpNo,
        queryType: "18",
      },
    };
    var response = JSON.parse(getCarInfoByCode(JSON.stringify(request)));
    if (response == null || response.respcode != "000") {
      this.errormessage =
        "车牌查询失败, 错误信息:" +
        response.respMessage +
        "，错误代码：" +
        response.respcode;
      return;
    }

    if (response.data != null) {
      //txtCarSign.Text = response.data.carSign;
      //txtCarType.Text = response.data.carType;
      //txtOldTareWeight.Text = response.data.tareWeight.toString();
      this.formmodel2.input_CarSign = response.data.carSign;
      this.formmodel2.input_CarType = response.data.carType;
      this.formmodel2.input_OldTareWeight = response.data.tareWeight.toString();
    }

    //if (response.data == null || (string.IsNullOrEmpty(response.data.carSign) && string.IsNullOrEmpty(response.data.carType)))
    //{
    //    MessageBox.Show("没有找到该车牌对应的车辆信息", "警告", MessageBoxButtons.OK, MessageBoxIcon.Warning);
    //}

    //this.combokbox1.Text = cpNo;
    this.formmodel2.input_LicensePlateNumber = cpNo;

    //触发称重事件
    this.WeighRequest(cpNo);
    //tbx_scanArea.Text = "";
    this.formmodel2.input_ScanCode = "";
    // callbackdic["updateformdatacallback"]?.ExecuteAsync(SCANOBJECT);
  }
  // public QueryFacadeCallback(result) {
  //   if (
  //     this.formmodel2.input_LicensePlateNumber !=
  //     result.input_LicensePlateNumber
  //   ) {
  //     this.formmodel2.input_LicensePlateNumber =
  //       result.input_LicensePlateNumber;
  //   }
  //   if (this.formmodel2.input_OldTareWeight != result.input_OldTareWeight) {
  //     this.formmodel2.input_OldTareWeight = result.input_OldTareWeight;
  //   }
  //   if (this.formmodel2.input_WeightDate != result.input_WeightDate) {
  //     this.formmodel2.input_WeightDate = result.input_WeightDate;
  //   }
  //   if (this.formmodel2.input_CarSign != result.input_CarSign) {
  //     this.formmodel2.input_CarSign = result.input_CarSign;
  //   }
  //   if (this.formmodel2.input_CarType != result.input_CarType) {
  //     this.formmodel2.input_CarType = result.input_CarType;
  //   }
  //   if (this.formmodel2.input_TareWeight != result.input_TareWeight) {
  //     this.formmodel2.input_TareWeight = result.input_TareWeight;
  //   }
  // }
  public carlabel = "";
  private config = config;

  private formmodel2: inputDataModel_WeighbridgeTare = {
    input_ScanCode: "",
    input_LicensePlateNumber: "",
    input_OldTareWeight: "",
    input_WeightDate: "",
    input_CarSign: "",
    input_CarType: "",
    input_TareWeight: "",
  };
  public showPrintedList = [];

  public options = [
    {
      value: "",
      label: "",
    },
  ];
}
